import { ConsumptionsVm } from '@navstation-portal/reporting/data-model/vessel-report';
import { CalculatedValue } from '../with-calculated-values';

// V1 always draws three fuel columns, and the store holds three in every init
// mode.
const FUEL_COLUMNS = [0, 1, 2];

// The store holds one entry for each fuel column. The template holds one field
// for each value, for example cargoRelated, and no field for each fuel column.
// So the rules of one field apply to the value in each fuel column.
const columnValue = (
  sectionId: string,
  property: string,
  index: number,
  value: number | undefined
): CalculatedValue => ({
  sectionId,
  fieldId: 'entries',
  index,
  property,
  value,
  rule: { sectionId, fieldId: property },
});

const fuelColumnValues = (vm: ConsumptionsVm, index: number): CalculatedValue[] => [
  columnValue('totalConsumptions', 'total', index, vm.calculateTotal(index)),
  columnValue('totalConsumptions', 'cargoRelated', index, vm.calculateCargoRelated(index)),
  columnValue('auxEngineConsumptions', 'basicLoad', index, vm.calculateAEBasicLoad(index)),
  columnValue('boilerConsumptions', 'basicLoad', index, vm.calculateABBasicLoad(index)),
];

/**
 * Every Calculated Value of the Consumptions tab. `withCalculatedValues`
 * writes each one to the form state, and ReportStore sets its status.
 */
export const collectConsumptionsCalculatedValues = (vm: ConsumptionsVm): CalculatedValue[] => [
  ...FUEL_COLUMNS.flatMap((index) => fuelColumnValues(vm, index)),
  { sectionId: 'cylinderOilConsumption', fieldId: 'oilKgConsumption', value: vm.cylinderOilKgConsumption },
  { sectionId: 'cylinderOilConsumption', fieldId: 'oilSloc', value: vm.cylinderOilSloc },
];
